<div class="app-common-viewer-container">
  <div>
    <!-- <div class="row m-0 p-0 shadow-sm _wf-historytabmaincontainer justify-content-end">
    <div>
      <div class="row pull-right"
        *ngIf="!utilService.isMobile() && currentData['resouceDef'].config.action_buttons != undefined && this.currentData['selectedList'] != undefined && this.currentData['selectedList'] != {}">
        <div *ngFor="let buttons of currentData['resouceDef'].config.action_buttons" class="mr-2">
          <button type="button" class="btn-with-icon-label" (click)="onButtonClicked(buttons)">
            <i aria-hidden="true" [class]="buttons.class"></i>
            <span>{{buttons.label | translate | async}}</span>
          </button>
        </div>
      </div>
    </div>
  </div> -->
  <!-- content -->
  <div class="row m-0 p-0 shadow-sm _wf-historytabmaincontainer">
    <div class="cursor-pointer m-0 p-0 max-width-card" id="scrollTestLab" scroll-directive>
      @if (currentData.list!=undefined && currentData.list.length > 0) {
        <div>
          @for (entity of currentData.list; track entity; let i = $index) {
            <div #activeTab class="_wf-historytab doc-view-list row"
              [ngClass]="!this.utilService.isMobile() ?{'doc-active-tab': i==0?true:false} : ''"
              (click)="!this.utilService.isMobile() ? [setView(entity), activeTab.classList.toggle('doc-active-tab')] : mobileEventCall(entity)"
              [id]="'labtestList' +i">
              <!-- for small screens show action buttons -->
              <!-- <div class="w-100" *ngIf="utilService.isMobile()">
              <div class="_card-actions-container d-block pull-right">
                <div class="card-three-dots-container card-action"
                  (click)="dropdownMenuRef.classList.toggle('show')">
                  <i aria-hidden="true" class="fa fa-ellipsis-v"></i>
                </div>
              </div>
            </div> -->
            @if (currentData['resouceDef'] && currentData['resouceDef'].config && currentData['resouceDef'].config.action_buttons) {
              <div class="_table-quick-actions" #dropdownMenuRef style="width: 100%;">
                <div class="_table-quick-actions-items">
                  @for (buttons of currentData['resouceDef'].config.action_buttons; track buttons) {
                    <button type="button" (click)="onButtonClicked(buttons)">
                      <i aria-hidden="true" [class]="buttons.class"></i>
                      <span>{{buttons.label | translate | async}}</span>
                    </button>
                  }
                </div>
              </div>
            }
            @for (field of currentData.fields; track field) {
              @if ((field.type == undefined && entity[field.name] != undefined) || field.type == 'composite') {
                <div
                  [ngClass]="field.show_heading != undefined && !field.show_heading ? '_wf-historytabheading' : (field.class_name ? field.class_name : '_wf-historytableft')">
                  @if (field.show_heading == undefined || field.show_heading) {
                    <span class="wf0historycategory"
                      >
                    {{field.heading|translate|async}}</span>
                  }
                  @if ((field.type == undefined && entity[field.name] != undefined) || field.type == 'composite') {
                    <div [ngClass]="field.show_heading != undefined && !field.show_heading ? '_wf-cf-heading' : '_wf-historybolddata'"
                      >
                      {{entity
                      | mapvalue : field}}
                    </div>
                  }
                </div>
              }
              @if (field.type == 'datetime') {
                <div [ngClass]="field.class_name ? field.class_name : '_wf-historytableft'">
                  <div class="wf0historycategory">{{field.heading}}</div>
                  <div class="_wf-historybolddata">{{entity | mapvalue : field | dateTimeFormat}}</div>
                </div>
              }
              @if (field.type == 'event' && checkExpression(field,entity)) {
                <div [ngClass]="field.class_name ? field.class_name : '_wf-historytableft'"
                  >
                  <div class="_wf-historybolddata"><a href="javascript:void(0)"
                  (click)="eventHandler(entity,field)">{{field.heading}}</a></div>
                </div>
              }
            }
          </div>
        }
      </div>
    }
    @if (utilService.isMobile()) {
      <div class="row btn-margin  mt-3">
        @if (currentData && currentData['resouceDef']) {
          <div class="col-12 text-center">
            @for (buttons of currentData['resouceDef'].config.action_buttons; track buttons) {
              <div class="mr-2">
                @if (checkPermission(buttons)) {
                  <button type="button" class="primary-btn mr-1 ml-1" (click)="onButtonClicked(buttons)" >
                    <span>{{buttons.label | translate | async}}</span>
                    <i class="fa fa-plus-square" aria-hidden="true"></i>
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <!-- for form -->
  @if (currentData.show && currentData.list.length > 0) {
    <div class="_wf-patienthistory box-shadow"
      id="scrollTestLab " scroll-directive>
      @if (this.utilService.isMobile()) {
        <div class="d-flex justify-content-end crossbutttoninhistory"><i
          aria-hidden="true" class="fa fa-times-circle" style="font-size: 1.5em;"
        (click)="closeButton()"></i></div>
      }
      @if (currentData.selectedList) {
        <div>
          @if (currentData['questionForm']) {
            <dhs-form [formtype]="''" [config]="config"
              [fieldGroup]="currentData['questionForm']" (saveFinished)="onSaveFinished($event)"
              [data]="currentData['formData']" [action]="'ADD'" [customButton]="currentData['btn']"
              [decorator]="self">
            </dhs-form>
          }
        </div>
      }
    </div>
  }
</div>
</div>
@if (!utilService.isMobile()) {
  <div class="row btn-margin mt-3">
    @if (currentData['resouceDef']!=undefined && currentData['resouceDef'].config!=undefined && currentData['resouceDef'].config.action_buttons != undefined && this.currentData['selectedList'] != undefined && this.currentData['selectedList'] != {}) {
      <div class="col-12 text-center"
        >
        @for (buttons of currentData['resouceDef'].config.action_buttons; track buttons) {
          <div class="mr-2">
            @if (checkPermission(buttons)) {
              <button type="button" class="primary-btn mr-1 ml-1" (click)="onButtonClicked(buttons)">
                <span>{{buttons.label | translate | async}}</span>
                <i class="fa fa-plus-square" aria-hidden="true"></i>
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
}
@if (currentData.list && currentData.list.length == 0) {
  <div class="no-record-found">
    <div class="no-record-found-img-container">
      <img src="assets/images/nodata-icon.svg" class="no-records-found"/>
      <div class="no-records-found-text">
        <span >{{'field.label.no_records_found' | translate | async}}</span>
      </div>
    </div>
  </div>
}
</div>